module.exports = __webpack_public_path__ + "img/Rear bumper.6405f234.jpg";